import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        debug: false,
        pixelID: '2637590023227348',
        accessCode: 'GPPLR:20',
        // accessCode: '',
        // debugCode: 'j5e(H!',
        debugCode: 'a',
        lsCode:     'Biboun92!',
        userParams: {
            username: '',
            password: '',
            disclaimerAccepted: false,
            localStorage: false,
            expiry: 0,
            defaultLevels: [],
        },
        username: '',
        accessGranted: false,
        isFirstTraining: false,
        soundMode: false,
        exercises: [
            {
                ref: 'pve',
                name: 'Planche ventrale',
                defaultLevel: 3,
                levels: [{rank:1}, {rank:2}, {rank:3}, {rank:4}, {rank:5},
                    {rank:6}, {rank:7}, {rank:8}, {rank:9}, {rank:10}],
                images: [   '1-planche-ventrale/n1.png', '1-planche-ventrale/n2.png',
                    '1-planche-ventrale/n3.png', '1-planche-ventrale/n4.png',
                    '1-planche-ventrale/n5.png', '1-planche-ventrale/n6.png',
                    '1-planche-ventrale/n7.png', '1-planche-ventrale/n8.png',
                    '1-planche-ventrale/n9.png', '1-planche-ventrale/n10.png',
                ]
            },
            {
                ref: 'plo',
                name: 'Planche Lombaire',
                defaultLevel: 3,
                levels: [{rank:1}, {rank:2}, {rank:3}, {rank:4}, {rank:5},
                    {rank:6}, {rank:7}, {rank:8}, {rank:9}, {rank:10}],
                images: [   '2-planche-lombaire/n1.png', '2-planche-lombaire/n2.png',
                    '2-planche-lombaire/n3.png', '2-planche-lombaire/n4.png',
                    '2-planche-lombaire/n5.png', '2-planche-lombaire/n6.png',
                    '2-planche-lombaire/n7.png', '2-planche-lombaire/n8.png',
                    '2-planche-lombaire/n9.png', '2-planche-lombaire/n10.png',
                ]
            },
            {
                ref: 'pld',
                name: 'Planche Latérale Droite',
                defaultLevel: 3,
                levels: [{rank:1}, {rank:2}, {rank:3}, {rank:4}, {rank:5},
                    {rank:6}, {rank:7}, {rank:8}, {rank:9}, {rank:10}],
                images: [   '3-planche-laterale-droite/n1.png', '3-planche-laterale-droite/n2.png',
                    '3-planche-laterale-droite/n3.png', '3-planche-laterale-droite/n4.png',
                    '3-planche-laterale-droite/n5.png', '3-planche-laterale-droite/n6.png',
                    '3-planche-laterale-droite/n7.png', '3-planche-laterale-droite/n8.png',
                    '3-planche-laterale-droite/n9.png', '3-planche-laterale-droite/n10.png',
                ]
            },
            {
                ref: 'plg',
                name: 'Planche Latérale Gauche',
                defaultLevel: 3,
                levels: [{rank:1}, {rank:2}, {rank:3}, {rank:4}, {rank:5},
                    {rank:6}, {rank:7}, {rank:8}, {rank:9}, {rank:10}],
                images: [   '4-planche-laterale-gauche/n1.png', '4-planche-laterale-gauche/n2.png',
                    '4-planche-laterale-gauche/n3.png', '4-planche-laterale-gauche/n4.png',
                    '4-planche-laterale-gauche/n5.png', '4-planche-laterale-gauche/n6.png',
                    '4-planche-laterale-gauche/n7.png', '4-planche-laterale-gauche/n8.png',
                    '4-planche-laterale-gauche/n9.png', '4-planche-laterale-gauche/n10.png',
                ]
            },
            {
                name: 'Pont Latéral Droit',
                defaultLevel: 3,
                levels: [{rank:1, name: 'Pont Unilatéral'}, {rank:2, name: 'Pont Unilatéral'}, {rank:3, name: 'Pont Unilatéral'}, {rank:4}, {rank:5},
                    {rank:6}, {rank:7}, {rank:8, name: 'Pont Unilatéral'}, {rank:9}, {rank:10}],
                images: [   '5-pont-lateral-droit/n1.png', '5-pont-lateral-droit/n2.png',
                    '5-pont-lateral-droit/n3.png', '5-pont-lateral-droit/n4.png',
                    '5-pont-lateral-droit/n5.png', '5-pont-lateral-droit/n6.png',
                    '5-pont-lateral-droit/n7.png', '5-pont-lateral-droit/n8.png',
                    '5-pont-lateral-droit/n9.png', '5-pont-lateral-droit/n10.png',
                ]
            },
            {
                name: 'Pont Latéral Gauche',
                defaultLevel: 4,
                levels: [ {rank:1, disabled: true}, {rank:2, disabled: true}, {rank:3, disabled: true}, {rank:4}, {rank:5},
                    {rank:6}, {rank:7}, {rank:8, disabled: true}, {rank:9}, {rank:10}],
                images: ['no-image-1', 'no-image-2',
                    'no-image-3', '6-pont-lateral-gauche/n4.png',
                    '6-pont-lateral-gauche/n5.png', '6-pont-lateral-gauche/n6.png',
                    '6-pont-lateral-gauche/n7.png', 'no-image-4',
                    '6-pont-lateral-gauche/n9.png', '6-pont-lateral-gauche/n10.png',
                ]
            },
        ],
        results: [
            [   {level: null, duration: null}, {level: null, duration: null},
                {level: null, duration: null}, {level: null, duration: null},
                {level: null, duration: null}, {level: null, duration: null}
            ],
            [   {level: null, duration: null}, {level: null, duration: null},
                {level: null, duration: null}, {level: null, duration: null},
                {level: null, duration: null}, {level: null, duration: null}
            ],
            [   {level: null, duration: null}, {level: null, duration: null},
                {level: null, duration: null}, {level: null, duration: null},
                {level: null, duration: null},{level: null, duration: null}
            ]
        ],

        /* global const */
        maxTime: 60,
    },
    getters: {
        debug: state => {
            return state.debug;
        },
        accessCode: state => {
            return state.accessCode;
        },
        pixelID: state => {
            return state.pixelID;
        },
        lsCode: state => {
            return state.lsCode;
        },
        debugCode: state => {
            return state.debugCode;
        },
        userParams: state => {
            return state.userParams;
        },
        username: state => {
            return state.username;
        },
        accessGranted: state => {
            return state.accessGranted;
        },
        isFirstTraining: state => {
            return state.isFirstTraining;
        },
        soundMode: state => {
            return state.soundMode;
        },
        exercises: state => {
            return state.exercises;
        },
        results: state => {
            return state.results;
        },
        maxTime: state => {
            return state.maxTime;
        }

    },
    mutations: {
        updateUsername: (state, payload) => {
            state.username = payload;
        },
        updateDebug: (state, payload) => {
            if(payload == true) {
                state.debug = true;
            } else {
                state.debug = false;
            }
        },
        updateUserParams: (state, payload) => {
          //payload est un objet, si la(les) key existe(ent) dans userParams, alors on la(les) met à jour
            console.log("UpdateUserParams");
            console.log(payload);
            let updated = false;
            for (const property in payload) {
                if(state.userParams.hasOwnProperty(property)) {
                    state.userParams[property] = payload[property];
                    updated = true;
                }
            }

            if(updated) {
                const parsed = JSON.stringify(state.userParams);
                localStorage.setItem('userParams', parsed);
            }
        },
        updateSound: (state, payload) => {
            if(payload == true) {
                state.soundMode = true;
            } else {
                state.soundMode = false;
            }
        },
        updateIsFirstTraining: (state, payload) => {
            if(payload == true) {
                state.isFirstTraining = true;
            } else {
                state.isFirstTraining = false;
            }
        },
        updateResults: (state, payload) => {
            state.results = payload;
        },
        grantAccess: (state) => {
            state.accessGranted = true;
        },
    },
    actions: {
        updateDebug: ({commit}, payload) => {
            commit('updateDebug', payload);
        },
        updateUsername: ({commit}, payload) => {
            commit('updateUsername', payload);
        },
        updateUserParams: ({commit}, payload) => {
            commit('updateUserParams', payload);
        },
        updateSound: ({commit}, payload) => {
            commit('updateSound', payload);
        },
        updateIsFirstTraining: ({commit}, payload) => {
            commit('updateIsFirstTraining', payload);
        },
        updateResults: ({commit}, payload) => {
            commit('updateResults', payload);
        },
        grantAccess: ({commit}) => {
            commit('grantAccess');
        }
    },
});


// WEBPACK FOOTER //
// ./src/store/store.js